import { fromJS } from 'immutable'

import * as substituteMaterialsActions from './substituteMaterialsActions'
import { getItemsFromResponse } from './substituteMaterialsActions'

/**
 * The catalog is held whole: `GET /SubstituteMaterials` answers every relation at once and there is
 * no pagination on the wire. Search, ordering and paging are derived in the client from `items`,
 * so there is no server pagination block to keep here.
 */
let initialState = fromJS({
	isLoading: false,
	isSaving: false,
	isImporting: false,
	items: []
})

/**
 * substituteMaterials reducer
 */
const substituteMaterialsReducer = (state = initialState, action) => {
	switch (action.type) {
		case substituteMaterialsActions.IS_LOADING_SUBSTITUTE_MATERIALS:
			return state.merge({
				isLoading: action.status
			})

		case substituteMaterialsActions.IS_SAVING_SUBSTITUTE_MATERIAL:
			return state.merge({
				isSaving: action.status
			})

		case substituteMaterialsActions.IS_IMPORTING_SUBSTITUTE_MATERIALS:
			return state.merge({
				isImporting: action.status
			})

		case substituteMaterialsActions.SET_SUBSTITUTE_MATERIALS:
			return state.setIn(['items'], fromJS(getItemsFromResponse(action.data)))

		default:
			return state
	}
}

export default substituteMaterialsReducer
